<script setup lang="ts">
import BaseLayout from "@/layouts/BaseLayout.vue";
import {GroupBy, Project, Upload, User} from "@/types";
import DashboardSidebar from "@/Pages/components/DashboardSidebar.vue";
import WelcomeCard from "@/components/cards/WelcomeCard.vue";
import UploadsHistory from "@/Pages/projects/components/UploadsHistory.vue";
import {Head} from "@inertiajs/vue3";
import {ref} from "vue";
import ApplicationLoginDialog from "@/layouts/components/ApplicationLoginDialog.vue";

interface Props {
    user: User
    recentProjects: Array<Project>
    uploads: GroupBy<Upload>
    authenticateApplication: boolean
    sealBox: string | null
}

defineOptions({layout: BaseLayout})
const props = defineProps<Props>()

const isApplicationLoginDialogOpen = ref(props.authenticateApplication)
</script>

<template>
    <Head title="SendCrypt" />
    <v-navigation-drawer
        class="px-2"
        width="320"
        mobile-breakpoint="md"
    >
        <dashboard-sidebar
            :user="props.user"
            :projects="props.recentProjects"
        />
    </v-navigation-drawer>
    <v-row
        class="fill-height"
        :no-gutters="true"
    >
        <v-col>
            <v-row class="ma-5">
                <v-col
                    cols="12"
                    lg="9"
                >
                    <h1 class="text-h6 mb-3">
                        Home
                    </h1>
                    <welcome-card />
                    <uploads-history
                        :uploads="uploads"
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    <application-login-dialog
        v-model="isApplicationLoginDialogOpen"
        :seal-box="props.sealBox"
    />
</template>

<style scoped>

</style>
